import classnames from 'classnames';
import { Location, LocationDescriptor } from 'history';
import React, { PropsWithChildren } from 'react';
import { Link } from 'react-router-dom';

import { Tooltip } from 'src/components/common/tooltip/Tooltip';

interface Props<S> extends React.HTMLAttributes<HTMLElement> {
  className?: string;
  fallbackTooltipContent?: React.ReactNode;
  to?:
    | LocationDescriptor<S>
    | ((location: Location<S>) => LocationDescriptor<S>);
}

export function ConditionalLink<S>({
  fallbackTooltipContent,
  children,
  to,
  className,
  ...other
}: PropsWithChildren<Props<S>>) {
  if (to) {
    return (
      <Link<S> to={to} className={className} {...other}>
        {children}
      </Link>
    );
  }
  if (fallbackTooltipContent) {
    return (
      <Tooltip label={fallbackTooltipContent}>
        <span
          className={classnames('cursor-not-allowed', className)}
          {...other}
        >
          {children}
        </span>
      </Tooltip>
    );
  }
  return (
    <span className={classnames('cursor-not-allowed', className)} {...other}>
      {children}
    </span>
  );
}
